import { sqliteTable, text, uniqueIndex } from "drizzle-orm/sqlite-core";
import { z } from "zod";
import { createdAt, id, updatedAt } from "../lib/types";
import { cuid, dateTime, string } from "../validator/common";

export enum TagType {
  GENERAL = 0,
  POWERLIFTING = 1,
  BODYBUILDING = 2,
  NUTRITION = 3,
  RECOVERY = 4,
  MENTAL = 5,
  EQUIPMENT = 6,
  TECHNIQUE = 7,
  COMMUNITY = 8,
  EVENTS = 9,
  OTHER = 10,
}

export const tagTypeNamesList = [
  "General",
  "Powerlifting",
  "Bodybuilding",
  "Nutrition",
  "Recovery",
  "Mental",
  "Equipment",
  "Technique",
  "Community",
  "Events",
  "Other",
] as const;

export function getTagTypeName(type: TagType): string {
  return tagTypeNamesList[type];
}

export type TagTypeName = (typeof tagTypeNamesList)[number];

export const tags = sqliteTable(
  "tags",
  {
    tagId: id,
    createdId: text("created_by").notNull(),
    tagTitle: text("tag_name").notNull(),
    category: text("category")
      .default(TagType.GENERAL.toString())
      .notNull()
      .$type<TagType>(),
    tagContent: text("tag_content").notNull(),
    updatedAt,
    createdAt,
  },
  (t) => [uniqueIndex("unique_conversation_id").on(t.tagId)],
);

export const selectTagschema = z.object({
  tagId: cuid,
  createdId: cuid,
  tagTitle: string,
  category: z.enum([
    "General",
    "Powerlifting",
    "Bodybuilding",
    "Nutrition",
    "Recovery",
    "Mental",
    "Equipment",
    "Technique",
    "Community",
    "Events",
    "Other",
  ]),
  tagContent: string,
  updatedAt: dateTime,
  createdAt: dateTime,
});

export const insertTagschema = z.object({
  tagTitle: string.min(3, "Tag title must be at least 3 characters long"),
  tagContent: string.min(10, "Tag content must be at least 10 characters long"),
  category: z.enum([
    "General",
    "Powerlifting",
    "Bodybuilding",
    "Nutrition",
    "Recovery",
    "Mental",
    "Equipment",
    "Technique",
    "Community",
    "Events",
    "Other",
  ]),
});

export const patchTagschema = z.object({
  tagId: cuid,
  tagTitle: string.min(3, "Tag title must be at least 3 characters long"),
  tagContent: string.min(10, "Tag content must be at least 10 characters long"),
  category: z.enum([
    "General",
    "Powerlifting",
    "Bodybuilding",
    "Nutrition",
    "Recovery",
    "Mental",
    "Equipment",
    "Technique",
    "Community",
    "Events",
    "Other",
  ]),
});
